import { render, staticRenderFns } from "./Cpd.vue?vue&type=template&id=63363e5e&scoped=true&"
import script from "./Cpd.vue?vue&type=script&lang=js&"
export * from "./Cpd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63363e5e",
  null
  
)

export default component.exports